import { Sun, Moon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useTheme } from '@/contexts/ThemeContext'

export const ThemeToggle = () => {
  const { resolvedTheme, toggleTheme } = useTheme()

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleTheme}
            aria-label={
              resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
            }
          >
            {resolvedTheme === 'dark' ? (
              <Sun className="h-5 w-5 transition-transform rotate-0 scale-100" />
            ) : (
              <Moon className="h-5 w-5 transition-transform rotate-0 scale-100" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
